export default (url, params) => {
  const query = Object
    .entries(params)
    .filter(([, value]) => typeof value !== 'undefined' && value !== null)
    .map(([name, value]) => `${name}=${value}`)
    .join('&');

  return `${url}?${query}`;
};
